/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./eval')} */
module.exports = EvalError;

